export default {
  ALL: '全部',
  DOTD_OR_SPECIAL_SALE_EVENT: '镇店之宝/特卖汇',
  REDUCE_THE_PRICE: '降价',
  ALREADY_SOLD_OUT: '已抢光',
  OUT_OF_STOCK_AT_PRESENT: '目前没货',
  PUT_ON_TOP: '置顶',
  NOT_FAVORITES_YET: '还没有收藏夹'
};
